import React from 'react';
import styled from 'styled-components';
import Calculator from './../../components/Calculator';

const LayoutWrapper = styled.div`
	margin: 0 auto;
	display: flex;
	@media(max-width: 1024px) {
		flex-direction: column;
	}
`;

const ContentWrapper = styled.div`
	width: 100%;
	// padding: 1em;
	@media(max-width: 1024px) {
		width: 100%;
	}
`;

// const Sidebar = styled.div`
// 	width: 25%;
// 	// padding: 1em;
// 	@media(max-width: 1024px) {
// 		width: 100%;
// 	}
// `;

const Wrap = styled.div`

  margin-left: 20px;
  margin-right: 20px;

  @media(max-width: 670px) {
		margin-left: .4em;
    margin-right: .4em;
  }

  .top {
		display: flex;
	}

`;

const Block = styled.div`
	background-color: white;
	padding-top: 1em;
	padding-bottom: 1em;
	padding-left: 30px;
	padding-right: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
  border-radius: 1em;
  border: 1px #e30986 solid;
`;

// const MobileBlock = styled.div`
// 	background-color: rgba(141, 44, 100, .1);
// 	padding-top: 2em;
// 	padding-bottom: 2em;
// 	padding-left: 3em;
// 	padding-right: 3em;
// 	margin-top: 2em;
// 	border-radius: 1em;
// 	margin-bottom: 1em;
// 	margin-left: 20px;
// 	margin-right: 20px;
// 	@media(min-width: 1024px) {
// 		display:none;
// 	}
// 	@media(max-width: 670px) {
// 		padding-left: 1.5em;
//     padding-right: 1.5em;
//     margin-left: .4em;
//     margin-right: .4em;
//     margin-top: 1em;
//     padding-top: .4em;
//     padding-bottom: .4em;
// 	}
// `;

const Logo = styled.div`
	text-align: right;
	img {
		width: 100%;
		max-width: 300px;
  }
  @media(max-width: 960px) {
		img { max-width: 250px; }
  }
  @media(max-width: 900px) {
		img { max-width: 200px; }
  }
  @media(max-width: 800px) {
		img { max-width: 150px; }
  }
`;

// const MobileLogo = styled.div`
// 	text-align: right;
// 	img {
// 		width: 100%;
// 		max-width: 250px;
// 	}
// 	display: none;
// 	@media(max-width: 1024px) {
// 		display: block;
// 	}
// `;

// const Banner = styled.div`
// 	@media(min-width: 1024px) {
// 		margin-bottom: 130px;
// 	}
// 	@media(max-width: 1024px) {
// 		padding-left: 1em;
// 		padding-right: 1em;
// 		padding-top: 1em;
// 	}
// 	img {
// 		width: 100%;
// 	}
// 	@media(max-width: 670px) {
// 		padding-left: .3em;
//     padding-right: .3em;
// 	}
// `;

// const Column = styled.div`
// 	position: relative;
// 	height: 100%;
// 	display: flex;
// 	flex-direction: column;
// 	justify-content: space-between;
// `;

const Footer = styled.p`
	font-size: .7em;
	margin-left: 3em;
	line-height: 1.7em;
	@media(max-width: 670px) {
		margin-left: 1em;
	}
`;

export const MainLayout = (props) => {
  return (
    <div>
      <LayoutWrapper>
        <ContentWrapper>
          <Wrap>
            <div className="top">
              <div style={{ flex: 1 }}>
                <h1>Cost of absenteeism calculator</h1>
                <h2>Discover how much absenteeism could cost your business</h2>
              </div>
              <Logo><img alt='' src='images/logo019x2.png' /></Logo>
            </div>
            <Block>
              <h3>Simply enter a few details to see the potential direct cost of absenteeism on your business.</h3>
              <p className='grey' >
                Don't worry if you don't know all your figures as we have provided UK averages as a guide.
                We'll use the information you have submitted to estimate the potential direct cost of
                absenteeism on your business. You can also see how reducing absenteeism by different amounts could affect your cost of absenteeism.
                </p>
              <p className='grey' ><b>Please note these results are only to be used as a guide and are not guaranteed.</b></p>
            </Block>

          </Wrap>
          <Calculator {...props} />
          <Wrap style={{ marginTop: 20 }}>
            <a href="" target="_blank" rel="noopener"><img src="images/banner019.jpg" alt="" style={{ width: '100%' }} /></a>
          </Wrap>
        </ContentWrapper>
      </LayoutWrapper>
      <Footer className='grey' >
        <sup>1</sup> 2018 ONS average salary of £29,588 <br />
        <sup>2</sup> CIPD, Health and well-being of work, April 2019.
			</Footer>
    </div>
  );
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/html/layouts/MainLayout/index.js